import { useCallback } from 'react';
import { useCableSubscription } from './useCableSubscription';
import { useUpdateExcerptFromCable } from 'hooks/excerpts/mutations/useUpdateExcerptFromCable';
import { isCurrentSession } from 'utils/SessionIDUtil';

/**
 * ExcerptCable component for handling excerpt-related cable events
 */
function ExcerptCable({ projectId }) {
  const updateExcerptFromCable = useUpdateExcerptFromCable(projectId);

  const handleExcerptCable = useCallback((response) => {
    // Skip processing if this response is from the current session
    // session_id in the response is the session ID that created this change
    if (response.session_id && isCurrentSession(response.session_id)) {
      return;
    }

    updateExcerptFromCable(response);
  }, [updateExcerptFromCable]);

  useCableSubscription({
    channel: { channel: 'ExcerptsChannel', project: projectId },
    onReceived: handleExcerptCable
  });

  return null;
}

export default ExcerptCable;
